import sIcon1 from "../images/department/brain.gif";
import sIcon2 from "../images/department/heart.gif";

const Services = [
  {
    id: "1",
    title: "Alfabetização Cognitiva:",
    description:
      "As atividades desenvolvem de forma lúdica e estruturada todas as habilidades que seu filho precisa para ler e escrever com fluência: linguagem, coordenação motora fina, grafismo, memória e raciocínio lógico.",
    Icon: sIcon1,
  },
  {
    id: "2",
    title: "Alfabetização Emocional:",
    description:
      "Aqui está o nosso grande segredo. Mais do que aprender a ler e escrever, seu filho vai aprender a lidar com os erros sem medo. Ele vai descobrir como transformar frustração em motivação, fortalecer a autoestima e desenvolver resiliência de forma leve — habilidades que o acompanharão por toda a vida. Com o Kit Neuroalfabetização, seu filho não aprende apenas conteúdo. Ele aprende sobre si mesmo.",
    Icon: sIcon2,
  },
];
export default Services;
